<template>
  <div class="grb-data">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
      <el-breadcrumb-item>GRB数据维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item label="GRB ID">
          <el-input v-model="searchParams.grbid"></el-input>
        </el-form-item>

        <el-form-item label="Obs Time From">
          <el-date-picker
            v-model="searchParams.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Obs Time To">
          <el-date-picker
            v-model="searchParams.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini'  @click="grbinsert">新增</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="ind"
          label="IND"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="grb_id"
          label="GRB_ID">
        </el-table-column>
        <el-table-column
          prop="trigger_time"
          label="触发时间(MJD)">
        </el-table-column>
        <el-table-column
          prop="trigger_time_utc"
          label="触发时间(UTC)">
        </el-table-column>
        <el-table-column
          prop="ra"
          label="Ra">
        </el-table-column>
        <el-table-column
          prop="dec"
          label="Dec">
        </el-table-column>
        <el-table-column
          prop="start_utc"
          label="数据开始时间UTC">
        </el-table-column>
        <el-table-column
          prop="start_tt"
          label="数据开始时间tt">
        </el-table-column>
        <el-table-column
          prop="duration"
          label="观测时长"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="data_mode"
          label="数据模式"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="status"
          label="数据状态"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="relate_id"
          label="Relate_ID">
        </el-table-column>
        <el-table-column
          prop="file_id"
          label="文件ID">
        </el-table-column>
        <el-table-column
          prop="release_date"
          label="发布日期">
        </el-table-column>

        <el-table-column
          width="100"
          label="操作">
          <template slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="grbEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.ind"
              type="text"
              size="small"
              @click="grbDelete(scope.row.ind)">
              删除
            </el-button>             
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
      <el-dialog title="GRB数据新增" :visible.sync="grbIsVisible" @close="closegrbInsertDialog">
        <el-form :inline="true" :model="grbForm" label-position="right">
          <el-form-item label="GRB_ID">
          <el-input v-model="grbForm.grb_id" autocomplete="off" style="width:290px;"></el-input>
        </el-form-item>
        <el-form-item label="触发时间(MJD)">
          <el-date-picker v-model="grbForm.trigger_time" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss" type="datetime" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="触发时间(UTC)">
          <el-input v-model="grbForm.trigger_time_utc" autocomplete="off" style="width:265px;"></el-input>
        </el-form-item>
        <el-form-item label="ra">
          <el-input v-model="grbForm.ra" autocomplete="off" style="width:260px;"></el-input>
        </el-form-item>
        <el-form-item label="开始时间UTC">
          <el-date-picker v-model="grbForm.start_utc" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss" type="datetime" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="dec">
          <el-input v-model="grbForm.dec" autocomplete="off" style="width:260px;"></el-input>
        </el-form-item>      
        <el-form-item label="开始时间tt">
          <el-input v-model="grbForm.start_tt" autocomplete="off" style="width:280px;"></el-input>
        </el-form-item>
        <el-form-item label="观测时长">
          <el-input v-model="grbForm.duration" autocomplete="off" style="width:260px;"></el-input>
        </el-form-item>
        <el-form-item label="数据模式">
          <el-select style="width:290px;" v-model="grbForm.data_mode"  filterable placeholder="数据状态">
                <el-option
                    v-for="item in datamode_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据状态">
          <el-select style="width:260px;" v-model="grbForm.status"  filterable placeholder="数据状态">
                <el-option
                    v-for="item in status_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Relate_ID">
          <el-input v-model="grbForm.relate_id" autocomplete="off" style="width:285px;"></el-input>
        </el-form-item>        
        <el-form-item label="文件__ID">
          <el-input v-model="grbForm.file_id" autocomplete="off" style="width:260px;"></el-input>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker v-model="grbForm.release_date" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:290px;"></el-date-picker>
        </el-form-item>               
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closegrbInsertDialog">取消</el-button>
          <el-button type="primary" @click="confirmgrbInsertDialog">确定</el-button>
        </div>
      </el-dialog>
      <GrbEditDialog
        :dialog-visible="GrbEditIsVisible"
        :dialog-data="currentDataId"
        @ok="confirmGrbEditDialog"
        @close="closeGrbEditDialog">
      </GrbEditDialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import GrbEditDialog from './GrbEditDialog.vue';
import {datastatus_IE,DataMode} from '../common';
export default {
  name: 'GrbData',
  components: {
    GrbEditDialog,
  },
  data() {
    return {
      searchParams: {
        grbid: '',
        startTime: '',
        endTime: '',
      },
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      status_list:datastatus_IE,
      datamode_list:DataMode,
      grbForm:{
        grb_id:'',
        trigger_time:'',
        trigger_time_utc:'',
        ra:'',
        dec:'',
        start_utc:'',
        start_tt:'',
        duration:'',
        data_mode:'',
        status:'',
        relate_id:'', 
        file_id:'', 
        release_date:'',      
      },
      grbIsVisible:false,
      GrbEditIsVisible:false,
      currentDataId:null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/Grb', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    grbinsert(){
      this.grbIsVisible = true ;
      this.grbForm.grb_id='';
      this.grbForm.trigger_time='';
      this.grbForm.trigger_time_utc='';
      this.grbForm.ra='';
      this.grbForm.dec='';
      this.grbForm.start_utc='';
      this.grbForm.start_tt='';
      this.grbForm.duration='';
      this.grbForm.data_mode='';
      this.grbForm.status='';
      this.grbForm.relate_id='';
      this.grbForm.file_id='';
      this.grbForm.release_date='';
    },
    confirmgrbInsertDialog(){
      this.closegrbInsertDialog();
      const params = {
        ...this.grbForm,
      };
      axios.post('/iapi/Grbinsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增GRB数据成功！');
        }
      });
      this.getData();
    },
    closegrbInsertDialog(){
      this.grbIsVisible = false;
    },
    grbDelete(DataID){
      const params = {
        data_id: DataID,
      };
      axios.post('/iapi/Grbdelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除GRB数据成功！');
        }
      });
      this.getData();
    },
    grbEdit(dataId){
      this.GrbEditIsVisible = true;
      this.currentDataId = dataId;
    },
    closeGrbEditDialog(){
      this.GrbEditIsVisible = false;
    },
    confirmGrbEditDialog(data){
      this.closeGrbEditDialog();
      const params = {
        grb_id:data.grb_id,
        trigger_time:data.trigger_time,
        trigger_time_utc:data.trigger_time_utc,
        ra:data.ra,
        dec:data.dec,
        start_utc:data.start_utc,
        start_tt:data.start_tt,
        duration:data.duration,
        data_mode:data.data_mode,
        status:data.status, 
        relate_id:data.relate_id, 
        file_id:data.file_id, 
        release_date:data.release_date, 
        ind:data.ind,        
      }
      axios.post('/iapi/Grbedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑GRB数据成功！');
        }
      });
      this.getData();  
    },
  },
};
</script>

<style scoped>
.grb-data {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>